import { compose, branch, withProps, renderComponent } from 'recompose';

import VideoContentPending from 'modules/appointmentInfo/components/_placeholders/VideoContentPending';
import VideoSidebarEmptyPlaceholder from './VideoSidebarEmptyPlaceholder';

export default compose(
  withProps({
    isReactNative: /RnUmmanu/.test(navigator.userAgent),
  }),
  branch(({ isReactNative }) => isReactNative, renderComponent(VideoContentPending)),
)(VideoSidebarEmptyPlaceholder);
